export default function ChallengesSection() {
  const challenges = [
    {
      icon: 'ri-time-fill',
      title: 'Time-Consuming Traditional Sales',
      problem: 'Traditional apartment sales take 6-12 months on average, involving multiple showings, negotiations, inspections, and financing contingencies.',
      solution: 'We close in 7-14 days with cash, eliminating months of uncertainty and carrying costs.'
    },
    {
      icon: 'ri-group-fill',
      title: 'Difficult Tenant Situations',
      problem: 'Dealing with problem tenants, lease agreements, security deposits, and potential evictions makes selling apartments complicated.',
      solution: 'We buy apartments with tenants in place and handle all tenant relationships and transitions.'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Expensive Repairs & Maintenance',
      problem: 'Buyers expect apartments in good condition, requiring costly repairs, renovations, and updates before listing.',
      solution: 'We buy apartments as-is, saving you tens of thousands in repair and renovation costs.'
    },
    {
      icon: 'ri-money-dollar-circle-fill',
      title: 'High Transaction Costs',
      problem: 'Real estate commissions (6%), closing costs, repairs, and holding costs can consume 10-15% of your sale price.',
      solution: 'No commissions, no fees. Our offer is what you receive, saving you thousands in transaction costs.'
    },
    {
      icon: 'ri-file-list-3-fill',
      title: 'Complex Paperwork & Legal Issues',
      problem: 'Apartment sales involve extensive documentation, rent rolls, lease assignments, tenant notifications, and legal compliance.',
      solution: 'We handle all paperwork and work through title companies to ensure legal compliance and proper documentation.'
    },
    {
      icon: 'ri-auction-fill',
      title: 'Financing Contingencies',
      problem: 'Most buyers need financing, which can fall through at the last minute, wasting months of your time.',
      solution: 'We pay cash with proof of funds, eliminating financing contingencies and ensuring certain closings.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Common Challenges
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Challenges of Selling Apartments the Traditional Way
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Selling apartment buildings through traditional methods presents numerous challenges. Here's how working with professional apartment buyers solves these problems.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {challenges.map((challenge, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-red-600 rounded-xl flex items-center justify-center mb-6">
                <i className={`${challenge.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{challenge.title}</h3>
              <div className="mb-4">
                <div className="text-sm font-semibold text-red-600 mb-2">THE PROBLEM:</div>
                <p className="text-gray-600 leading-relaxed">{challenge.problem}</p>
              </div>
              <div>
                <div className="text-sm font-semibold text-teal-600 mb-2">OUR SOLUTION:</div>
                <p className="text-gray-700 leading-relaxed font-medium">{challenge.solution}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-3 bg-teal-50 px-8 py-4 rounded-xl">
            <i className="ri-lightbulb-flash-fill text-teal-600 text-3xl"></i>
            <span className="text-lg text-gray-700 font-semibold">Skip the hassles—sell my apartments fast to experienced buyers</span>
          </div>
        </div>
      </div>
    </section>
  );
}